<template>
  <v-container fluid class="e-min-height grey-bg" style="/*padding-top: 75px;*/">
    <Diccionario :id_unit="this.idUnidad" :isPractice="true"/>
    <v-layout row wrap class="fill-height" style="min-height: calc(100vh - 96px);">
      <v-flex xs12>
        <HeaderFill title="Práctica Avanzado" :router="`/practica/avanzada/${this.idUnidad}`" :back="false"/>
        <v-progress-linear  :value="progress" color="yellow" height="5" class="e-progress"></v-progress-linear>
        <v-progress-circular v-if="loading" :size="50" color="primary" indeterminate></v-progress-circular>
        <v-stepper v-if="!loading" v-model="e1" class="e-stepper elevation-0 transparent ">
          <v-stepper-header class="hidden-screen-only">
            <v-stepper-step :complete="e1 > 1" step="1">Name of step 1</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 2" step="2">Name of step 2</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="3">Name of step 3</v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content 
              v-for="(lesson, index) in loadedLessons" 
              :key="`practiceB-${index}`" 
              :step="(index + 1)"
              >
              <!-- tipo 1 -->
              <SubCardColumnaFinal
                v-if="lesson.id_tipo_ejercicio == 1"
                :lesson="lesson"
                @clicked="respuestaSelected"
              />
              <!-- tipo 2 -->
              <CardFila
                v-if="lesson.id_tipo_ejercicio == 2"
                :textSpanish="lesson.instructions_spanish"
                :textExercise="lesson.exercise"
                :options="lesson.options"
                :answer="lesson.answer"
                @clicked="respuestaSelected"
              />
              <!-- tipo 3 -->
              <div v-if="lesson.id_tipo_ejercicio == 3">
                <div class="e-ejercicio-descripcion text-xs-left">
                  <p 
                    class="instruccion mb-2 pb-3" 
                    style="border-bottom: 1px solid #D3D4D8;"
                    v-html="lesson.instructions_spanish || lesson.instructions_korean">
                  </p>
                </div>
                <SubCardFila
                  v-for="(value, indexSCF) in lesson.options"
                  :key="`textSubCardFila-${indexSCF}`"
                  :respuesta="value"
                  :answer="lesson.answer"
                  :isValidar="true"
                  @clicked="respuestaSelected"
                />
              </div>
              <!-- tipo 4 -->
              <CardDragLine 
                v-if="lesson.id_tipo_ejercicio == 4"
                :idUnidad="idUnidad" 
                :textSpanish="lesson.instructions_spanish"
                :textExercise="lesson.exercise"
                :options="lesson.options"
                :answer="lesson.answer"
                :isIntermedio="false"
                @clicked="respuestaSelected"
                />
              <!-- tipo 5 -->
              <div v-if="lesson.id_tipo_ejercicio == 5" class="e-ejercicio">
                <div class="e-ejercicio-descripcion text-xs-left">
                  <p 
                    class="instruccion mb-2 pb-3" 
                    style="border-bottom: 1px solid #D3D4D8;"
                    v-html="lesson.instructions_spanish || lesson.instructions_korean">
                  </p>
                </div>
                <div class="e-ejercicio-ejercicio ejercicio-calendario pt-0">
                  <v-layout  pt-0 column>
                    <h3 class="e-sub-sub-title-md text-xs-left py-3 black-text" v-html="lesson.example"></h3>
                    <CardCalendario 
                      v-for="(calen, indexCal) in lesson.options"
                      :key="`textCalen-${indexCal}`"
                      :numero="calen.numero"
                      :diaKr="calen.texto" />
                  </v-layout>
                </div>
              </div>
              <!-- tipo 6 -->
              <CardCarouselFinal
                v-if="lesson.id_tipo_ejercicio == 6"
                :loadedLessons="lesson"
                :indexLesson="(index + 1)"
                @clicked="respuestaSelected"
              />
              <!-- tipo 7 -->
              <CardDrag
                v-if="lesson.id_tipo_ejercicio == 7"
                :textSpanish="lesson.instructions_spanish"
                :textExercise="lesson.exercise"
                :textExample="lesson.example"
                :options="lesson.options"
                :answer="lesson.answer"
                @clicked="respuestaSelected"
              />
              <!-- tipo 8 -->
              <CardColumna 
                v-if="lesson.id_tipo_ejercicio == 8"
                :textSpanish="lesson.instructions_spanish"
                :textExercise="lesson.exercise"
                :textMessage1="lesson.message_1"
                :textMessage2="lesson.message_2"
                :options="lesson.options"
                :answer="lesson.answer"
                @clicked="respuestaSelected"
              />
              <!-- tipo 9 -->
              <CardLectura 
                v-if="lesson.id_tipo_ejercicio == 9"
                :image="require('@/assets/images/unit/practice/' + lesson.imagen)"
                :textKr="lesson.large_text_korean"
                :textEs="lesson.large_text_spanish"
              />
              <!-- tipo 10 -->
              <CardPreguntaFinal
                v-if="lesson.id_tipo_ejercicio == 10"
                :loadedLessons="lesson"
                :currenStep="currenStep"
                @clicked="respuestaPreguntaFinal"
              />
              <v-btn 
                v-if="mostrarBoton(lesson,'MostrarTexto', index)"
                @click="openTexto(index)" outline 
                color="primary" round large class="my-3">
                <!--img :src="require('@/assets/images/practica/outline-text.svg')" alt="Lectura" style="height: 20px;margin-top: 2px;margin-right: 5px;"-->
                VER EL TEXTO COMPLETO
              </v-btn>
              <v-btn
                v-if="mostrarBoton(lesson,'Comprobar', index)"
                block
                round
                large
                class="elevation-0"
                color="verde-azul white--text"
                @click="validate(currenStep)"
              >
                Comprobar
              </v-btn>
              <v-btn
                v-if="mostrarBoton(lesson,'Continuar', index)"
                round
                large
                router-link
                color="primary"
                @click="continuar(currenStep)"
              >
                Continuar
              </v-btn>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-flex>
    </v-layout>
    <CardTextoFinal 
      :imageUnidad="loadedTextLessons.imagen"
      :textKr="loadedTextLessons.large_text_korean"
      :textEs="loadedTextLessons.large_text_spanish"
      :visible="this.texto" 
      @clicked="closeTexto"/>
    <Incorrecto :visible="this.error" @clicked="closeError"/>
    <Correcto :visible="this.success" :nextStep="`${currenStep}`" @clicked="closeSuccess"/>
  </v-container>
</template>

<script>
import CardDrag from '../../../components/Practica/basica/CardDrag'
import CardFila from '../../../components/Practica/basica/CardFila'
import CardColumna from '../../../components/Practica/basica/CardColumna'
import CardDragLine from '../../../components/Practica/intermedio/CardDragLine'
import CardLectura from '../../../components/Practica/intermedio/CardLectura'
import SubCardFila from '../../../components/Practica/basica/SubCardFila'
import CardCalendario from '../../../components/Practica/intermedio/CardCalendario'
import CardTextoFinal from '../../../components/Practica/Global/CardTextoFinal'
import SubCardColumnaFinal from '../../../components/Practica/Global/SubCardColumnaFinal'
import CardCarouselFinal from '../../../components/Practica/Global/CardCarouselFinal'
import CardPreguntaFinal from '../../../components/Practica/Global/CardPreguntaFinal'

import Correcto from '../../../components/Comprobar/Correcto'
import Incorrecto from '../../../components/Comprobar/Incorrecto'
import { storeFirebase } from '../../../store/firebase'

export default {
  name: 'PracticaEjerciciosAvanzado',
  props: ['idUnidad'],
  components: {
    CardDrag,
    CardFila,
    CardColumna,
    Incorrecto,
    CardDragLine,
    CardLectura,
    SubCardFila,
    CardCalendario,
    CardTextoFinal,
    SubCardColumnaFinal,
    CardCarouselFinal,
    CardPreguntaFinal
  },
  data () {
    return {
      e1: 0,
      error: false,
      success: false,
      currenStep: 1,
      finalStep: 0,
      loading: true,
      progress: 0,
      texto: false,
      respuestaCorrecta: false,
      loadedTextLessons: {
        imagen: '',
        large_text_korean: '',
        large_text_spanish: ''
      },
      progressUser: {}
    }
  },
  created () {
    this.loadLessons()
  },
  computed: {
    loadedLessons () {
      const dataValues = storeFirebase.getters.loadedPracticeLessons
      this.finalStep = dataValues.length
      return dataValues
    }
  },
  methods: {
    loadLessons () {
      const payload = {
        id_unit: Number(this.idUnidad),
        id_practice: 3
      }
      this.progressUser = storeFirebase.getters.userProgress
      storeFirebase.dispatch("loadPracticeLessons", payload).then(() => {
        setTimeout(() => {
          this.loading = false
        }, 2500)
      });
    },
    mostrarBoton(lessonItem, nombre, index) {
      switch (lessonItem.id_tipo_ejercicio) {
        case 5:
        case 9:
          if(nombre === 'Continuar') {
            return true
          }
          break
        case 10:
          if(nombre === 'MostrarTexto') {
            return this.validarTextoExiste(index)
          }
          break
        case 1:
        case 2:
        case 3:
          if(nombre === 'MostrarTexto') {
            return this.validarTextoExiste(index)
          }
        default:
          if(nombre === 'Comprobar') {
            return true
          }
          break
      }
      return false
    },
    validate (nextStep){
      if(this.respuestaCorrecta) {
        this.barraProgreso (this.currenStep)
        this.currenStep = (Number(nextStep) + 1)
        this.success = true
      } else {
        this.error = true
      }
    },
    continuar (nextStep) {
      this.currenStep = (Number(nextStep) + 1)
      this.e1 = this.currenStep
    },
    closeError (value) {
      this.error = value.visible
    },
    closeSuccess (value) {
      this.success = value.visible
      this.respuestaCorrecta = false
      if(this.finalStep < value.nextStep) {
        const routerPractice = `/practica/avanzada/${this.idUnidad}/ejercicio/practicaFin`
        this.$router.push(routerPractice)
      } else {
        setTimeout(() => {
          this.e1 = Number(value.nextStep)
        }, 200);
      }
    },
    barraProgreso (currentProgress) {
      this.progress = (100 / this.finalStep) * currentProgress
      if (this.progress >= 100) {
        this.sumarPractica();
      }
    },
    openTexto (index) {
      const dataValues = storeFirebase.getters.loadedPracticeLessons
      const totalIndex = (index - 1)
      for(let i = totalIndex; i >= 0; i--) {
        if(dataValues[i].id_tipo_ejercicio === 9) {
          this.loadedTextLessons = {
            imagen: dataValues[i].imagen,
            large_text_korean: dataValues[i].large_text_korean,
            large_text_spanish: dataValues[i].large_text_spanish
          }
          break
        }
      }
      this.texto = true
    },
    closeTexto () {
      this.texto = false
    },
    respuestaSelected (values) {
      let answer = values.answer.split(' ').reduce( (val, val2) => val + val2)
      answer = answer.replace(' ', '').replace('.', '')
      let userAnswer = ''
      if (values.userAnswer.length > 0) {
        userAnswer = values.userAnswer.reduce( (val, val2) => val + val2)
        userAnswer = userAnswer.split(' ').reduce( (val, val2) => val + val2)
        userAnswer = userAnswer.replace(' ', '').replace('.', '')
      }
      if (answer == userAnswer) {
        this.respuestaCorrecta = true
      } else {
        this.respuestaCorrecta = false
      }
    },
    respuestaPreguntaFinal (values) {
      if (values.answer === values.userAnswer) {
        this.respuestaCorrecta = true
      } else {
        this.respuestaCorrecta = false
      }
      this.validate(values.currenStep)
    },
    sumarPractica() {
      const unitVal = 'unit_' + this.idUnidad
      const progressPractice = this.progressUser.practice[unitVal]
      progressPractice[2].avanzada = 100
      this.updateUserProgress(this.progressUser)
    },
    validarTextoExiste(index) {
      const dataValues = storeFirebase.getters.loadedPracticeLessons
      const totalIndex = (index - 1)
      let textoExiste = false;
      for(let i = totalIndex; i >= 0; i--) {
        if(dataValues[i].id_tipo_ejercicio === 9) {
          textoExiste = true
          break
        }
      }
      return textoExiste
    },
    updateUserProgress(newUserProgress) {
      storeFirebase.dispatch('updateUserProgress', newUserProgress)
    }
  }
}
</script>
